<form name="deleteFertilizationYearForm">
  <div class="modal-header">
    <button type="button" class="close" ng-click="$dismiss();"><span>&times;</span></button>
    <h4 class="modal-title">{{'FERTILIZATION_PARCEL_FERTILIZATION_YEAR_DELETE' | translate}}</h4>
  </div>
  <div class="modal-body text-center">
    <h3>{{delete.item.label}}</h3>
  </div>
  <div class="modal-body" ng-bind-html="'FERTILIZATION_PARCEL_FERTILIZATION_YEAR_DELETE_CONFIRM' | translate"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$dismiss();">{{'ABORT' | translate}}</button>
    <button type="button" class="btn btn-danger" ng-click="$close();">{{'OK' | translate}}</button>
  </div>
</form>